var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnicallyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 150,
    rx: 12,
    fill: "#0f0f0f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 88,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 42,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "#ffffff"
  }, "technical.ly")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicallyLogo);
export default __webpack_public_path__ + "static/media/technically-logo.311bff5459472cab8f6711078d985a0a.svg";
export { ForwardRef as ReactComponent };